// 预设动作列表
import watermarkOverlay from './watermarkOverlay';
import testAction from './testAction';
import silverEmboss from './silverEmboss';

// 导出所有预设动作的数组
const presetActions = [
  {
    id: 1,
    name: '水印叠加',
    requiredLayers: 2,
    description: '水印叠加 (需上传2张图片)',
    execute: watermarkOverlay
  },
  {
    id: 2,
    name: '测试动作',
    requiredLayers: 3,
    description: '测试动作 (需上传3张图片)',
    execute: testAction
  },
  {
    id: 3,
    name: '镀银浮雕',
    requiredLayers: 2,
    description: '镀银浮雕 (需上传2张图片)',
    execute: silverEmboss
  }
];

// 导出预设动作数组
export { presetActions };

// 通过ID查找预设动作
export function getPresetById(id) {
  return presetActions.find(preset => preset.id === id);
}

// 导出预设动作的执行函数
export function executePreset(presetId, context) {
  const preset = getPresetById(presetId);
  if (preset && preset.execute) {
    return preset.execute(context);
  }
  throw new Error(`无效的预设动作ID: ${presetId}`);
} 